var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHostinactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99909 18.0029H3.33173C2.87154 18.0029 2.49805 17.6295 2.49805 17.1693V12.1672C2.49805 11.707 2.87154 11.3335 3.33173 11.3335H4.99909C5.45928 11.3335 5.83277 11.707 5.83277 12.1672V17.1693C5.83277 17.6295 5.45928 18.0029 4.99909 18.0029Z",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8341 14.6682H12.7791C13.1401 14.6682 13.4911 14.5515 13.7795 14.3348L15.7937 12.8241C16.2964 12.4473 17 12.4973 17.4444 12.9417V12.9417C17.9379 13.4352 17.9379 14.2347 17.4444 14.7274L15.7161 16.4557C15.251 16.9209 14.6574 17.2385 14.0121 17.3677L11.5694 17.8562C11.0851 17.9529 10.5857 17.9413 10.1063 17.8212L7.89706 17.2693C7.63278 17.2026 7.36184 17.1693 7.08922 17.1693H5.83203",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8341 14.6682H12.0721C12.7699 14.6682 13.3352 14.103 13.3352 13.4052V13.1526C13.3352 12.5732 12.9408 12.068 12.3789 11.9279L10.4681 11.4502C10.1572 11.3727 9.8387 11.3335 9.51857 11.3335V11.3335C8.74574 11.3335 7.9896 11.5619 7.34683 11.9913L5.83203 13.0009",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2086 3.97551L7.35287 3.97801C7.13195 3.97801 6.92019 4.06638 6.76429 4.22228L6.07651 4.91007C5.75054 5.23604 5.75054 5.76376 6.07651 6.08889L6.7668 6.77918C6.92269 6.93508 7.13528 7.02345 7.35621 7.02261L11.2111 7.02011L11.2203 7.02095C11.773 8.09389 12.8793 8.8342 14.1707 8.83253C16.0115 8.82753 17.5038 7.33107 17.5038 5.49114C17.5046 3.65037 16.014 2.16142 14.1732 2.16309C12.8868 2.16642 11.7831 2.90757 11.2278 3.97634",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1716 5.71793C14.2916 5.71793 14.3883 5.62039 14.3883 5.50034C14.3883 5.38029 14.29 5.28275 14.1707 5.28275C14.0507 5.28275 13.9532 5.38029 13.9532 5.50034C13.9532 5.62039 14.0507 5.71793 14.1716 5.71793",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostinactive);
export default __webpack_public_path__ + "static/media/hostinactive.1e1411b816ce7f9f028832607ec22ded.svg";
export { ForwardRef as ReactComponent };